import { Group, Radio, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { Period } from '../utils';

type PeriodToggleProps = {
  testId: string;
  period: Period;
  onPeriodChange: (period: Period) => void;
};

export function PeriodToggle({ testId, period, onPeriodChange }: PeriodToggleProps) {
  return (
    <Radio.Group
      value={period}
      onChange={value => onPeriodChange(value as Period)}
      data-testid={testId}
      style={{ pointerEvents: 'auto' }}
    >
      <Group gap="md" wrap="nowrap">
        <PeriodRadio value="monthly" label="Monthly" selected={period === 'monthly'} />
        <PeriodRadio value="annually" label="Annually" selected={period === 'annually'} />
      </Group>
    </Radio.Group>
  );
}

function PeriodRadio({
  value,
  label,
  selected,
}: {
  value: Period;
  label: string;
  selected: boolean;
}) {
  return (
    <Radio
      value={value}
      size="xs"
      color="brand.6"
      label={
        <Text fw={FONT_WEIGHTS.semibold} size="xs" c={selected ? 'brand.7' : 'gray.4'}>
          {label}
        </Text>
      }
      styles={{ radio: { borderColor: selected ? undefined : 'var(--mantine-color-gray-3)' } }}
    />
  );
}
